var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1111_1262)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 12.0002H14.8C13.1198 12.0002 12.2798 12.0002 11.638 12.3272C11.0735 12.6148 10.6146 13.0738 10.327 13.6383C10 14.28 10 15.1201 10 16.8002V25.2002C10 26.8804 10 27.7205 10.327 28.3622C10.6146 28.9267 11.0735 29.3856 11.638 29.6732C12.2798 30.0002 13.1198 30.0002 14.8 30.0002H23.2C24.8802 30.0002 25.7202 30.0002 26.362 29.6732C26.9265 29.3856 27.3854 28.9267 27.673 28.3622C28 27.7205 28 26.8804 28 25.2002V21.0002M16 24.0002H17.6745C18.1637 24.0002 18.4083 24.0002 18.6385 23.945C18.8425 23.896 19.0376 23.8152 19.2166 23.7055C19.4184 23.5818 19.5914 23.4089 19.9373 23.063L29.5 13.5002C30.3284 12.6718 30.3284 11.3287 29.5 10.5002C28.6716 9.6718 27.3284 9.6718 26.5 10.5002L16.9372 20.063C16.5913 20.4089 16.4184 20.5818 16.2947 20.7837C16.185 20.9626 16.1042 21.1577 16.0552 21.3618C16 21.5919 16 21.8365 16 22.3257V24.0002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1111_1262",
    x: -50,
    y: -50,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1111_1262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1111_1262",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.b45ca711989931b23402ee42d0b90b0a.svg";
export { ForwardRef as ReactComponent };